// Welcome, the last step: invite colleagues or skip (A5U20), on the welcome steps' card (A13U1, board getin-team). Owned
// by hand from here on.
import { ids } from '@orca/api-client/testIds'
import { createFileRoute } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'
import { InviteStep } from '../../../features/onboarding/InviteStep'
import { OnboardingFrame } from '../../../features/onboarding/OnboardingFrame'
import { meQuery } from '../../../shared/org/me'
import { Part } from '../../../shared/shell/StatePart'

export const Route = createFileRoute('/welcome/invite/$slug')({
  staticData: { screenId: 'OnboardingInviteScreen', access: 'owner of the organization just created' },
  loader: ({ context: { queryClient } }) => queryClient.ensureQueryData(meQuery()),
  component: OnboardingInviteScreen,
})

function OnboardingInviteScreen() {
  const { t } = useTranslation()
  const { slug } = Route.useParams()
  return (
    <OnboardingFrame
      testId={ids.onboardingInvite.root}
      step={3}
      title={t('onboarding.inviteStep.title')}
      lead={t('onboarding.inviteStep.lead')}
    >
      <Part testId={ids.onboardingInvite.skeleton}>
        <InviteStep orgSlug={slug} />
      </Part>
    </OnboardingFrame>
  )
}
